// Need to use the React-specific entry point to import createApi
import type {
  GetListResponseOfNotificationRuleSimpleResponse,
  GetNotificationRuleListRequest,
  GetNotificationRuleListRequestV2,
  GetNotificationVariablesRequest,
  GetNotificationVariablesResponse,
  NotificationRuleRequest,
  NotificationRuleResponse,
} from 'src/api/ProactApiClient';
import {notificationRuleApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery, voidClientQuery} from '../clientQuery';

// Define a service using a base URL and expected endpoints
export const notificationRuleApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getNotificationRuleList: builder.query<
      GetListResponseOfNotificationRuleSimpleResponse,
      GetNotificationRuleListRequest
    >({
      queryFn: clientQuery(params => notificationRuleApiClient.list(params)),
      providesTags: ['NotificationRules'],
    }),

    getNotificationRuleVariables: builder.query<
      GetNotificationVariablesResponse,
      GetNotificationVariablesRequest
    >({
      queryFn: clientQuery(params =>
        notificationRuleApiClient.getNotificationVariables(params)
      ),
    }),

    getNotificationRuleListV2: builder.query<
      GetListResponseOfNotificationRuleSimpleResponse,
      GetNotificationRuleListRequestV2
    >({
      queryFn: clientQuery(params => notificationRuleApiClient.listV2(params)),
      providesTags: ['NotificationRules'],
    }),

    getNotificationRule: builder.query<NotificationRuleResponse, number>({
      queryFn: clientQuery(id => notificationRuleApiClient.get(id)),
      providesTags: ['NotificationRules'],
    }),

    createNotificationRule: builder.mutation<
      NotificationRuleResponse,
      NotificationRuleRequest
    >({
      queryFn: clientQuery(request =>
        notificationRuleApiClient.create(request)
      ),
      invalidatesTags: ['NotificationRules'],
    }),

    updateNotificationRule: builder.mutation<
      NotificationRuleResponse,
      NotificationRuleRequest
    >({
      queryFn: clientQuery(request =>
        notificationRuleApiClient.update(request)
      ),
      invalidatesTags: ['NotificationRules'],
    }),

    deleteNotificationRule: builder.mutation<void, number>({
      queryFn: voidClientQuery(id => notificationRuleApiClient.delete(id)),
      invalidatesTags: ['NotificationRules'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetNotificationRuleListQuery,
  useGetNotificationRuleListV2Query,
  useGetNotificationRuleVariablesQuery,
  useGetNotificationRuleQuery,
  useCreateNotificationRuleMutation,
  useUpdateNotificationRuleMutation,
  useDeleteNotificationRuleMutation,
} = notificationRuleApi;
